module.exports = __webpack_public_path__ + "static/media/Car-accessories.d0330467.png";